import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 15,
		height: 15,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function RecommendedIcon(props) {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="7.5" cy="7.5" r="7.5" fill={props.fill} />
			<path d="M5.49988 7.50012L8.99985 7.5001" stroke="white" strokeLinecap="round" />
			<path d="M8 6L9 7.5L8 9" stroke="white" strokeLinecap="round" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<RecommendedIcon fill={props.fill} />
		</div>
	);
}